import moment from "moment";
import { createAction } from "@reduxjs/toolkit";
import { generateUUID } from "utils/appUtil";


const initialState = {
  // searchResult: [{
  // 	pageId: 1,
  // 	title: 'Emergency Page Name',
  // 	date: '03/02/21 11:33 PM',
  // 	icon: '',
  // 	number: '923122331111',
  // 	lastMessage: 'Last message long text here',
  // 	count: 15,
  // 	type: 'orange'
  // },
  // {
  // 	pageId: 2,
  // 	title: '03/02/21 - 11:33 PM',
  // 	date: '03/02/21 11:33 PM',
  // 	icon: '',
  // 	number: '923122331111',
  // 	lastMessage: 'last message',
  // 	count: 2,
  // 	type: 'green'
  // },
  // {
  // 	pageId: 3,
  // 	title: 'Very Long Title Lorem Ipsum Lorem ipsum',
  // 	date: '03/02/21 11:33 PM',
  // 	icon: '',
  // 	number: undefined,
  // 	lastMessage: 'last message',
  // 	count: 12,
  // 	type: 'blue'
  // },
  // {
  // 	pageId: 4,
  // 	title: 'Very Long Title Lorem Ipsum Lorem ipsum',
  // 	date: '03/02/21 11:33 PM',
  // 	icon: '',
  // 	number: '923122331111',
  // 	lastMessage: 'last message',
  // 	count: 10,
  // 	type: 'blue'
  // }],
  searchResult: [],
  readBy: [],
  selectedItem: {
    // id: 1,
    // title: 'Emergency Page Name',
    // date: '03/02/21 11:33 PM',
    // icon: '',
    // number: '923122331111',
    // lastMessage: 'Last message long text here',
    // count: 15,
    // type: 'orange'
  },
  twilioToken: "",
  mapType: "PAGE",
  callNotification: undefined,
  saveRecordingNotification: undefined,
  twilioVideoURL: undefined,
  searchLoading: false,
  pageConnection: undefined,
  searchPage: {offset: 0, limit: 10, scroll: true},
  searchArgs: {paginate: false},
  requestIds: {
    page: generateUUID(),
    message: generateUUID(),
  }
};

const getSearch = (state: SearchState): SearchState => ({
  ...state,
  searchLoading: true,
});

const getSelectedSearchItem = (
  state: SearchState,
  action: any
): SearchState => ({
  ...state,
  selectedItem: action.payload,
});

const getSearchResults = (state: SearchState, action: any): SearchState => {
  // const filter = JSON.parse(localStorage.getItem('filter'));
  let read, pending = undefined;
  // if(filter?.sort === 'Read/Unread')read = filter.order !== 'ASC';
  // if(filter?.sort === 'Relevance')pending = filter.order !== 'ASC';
  let results = action.payload;
  //   if(filter){
  //      const {liveIoT} = filter;
  //      if(liveIoT.indexOf('GPS') !== -1){
  //        results = results.filter((result)=>{
  //          let activeIot = false;
  //          let connections = result.nonpersistent.static.live.connections;
  //          Object.keys(connections).map((index)=>{
  //            if(Object.keys(connections[index].activeIot || {}).length > 0)
  //            activeIot = true;
  //          })
  //          return activeIot;
  //        })
  //      }
  //      if(liveIoT.indexOf('Video') !== -1){
  //       results = results.filter((result)=>{
  //         if(result?.nonpersistent?.dynamic?.live?.activeCall?.roomId)return true;
  //         else return false;
  //       })
  //     }
  //   }

  let {searchPage, searchArgs} = state;
  let searchResult = state?.searchArgs?.paginate ? [...state.searchResult, ...results]: results;
  return{
    ...state,
    searchResult,
    searchPage: action.payload.length < searchPage.limit ? {...searchPage, scroll: false}: {...searchPage, offset: searchPage.offset + searchPage.limit},
    searchArgs: (action.payload.length < searchPage.limit && (searchArgs?.args?.read !== read || searchArgs?.args?.pending !== pending)) ? {...searchArgs, paginate: true, args: {read, pending}}: searchArgs,
    selectedItem:
    searchResult.length > 0
        ? state.selectedItem?.pageId
          ? searchResult.find(
              (item: SelectedSearchItem) =>
                item.pageId === state.selectedItem?.pageId
            )
          : searchResult[0]
        : {},
}}

const onPageRemoved = (state: SearchState, action: any): SearchState => {
  let pages = [...state.searchResult];
	let index = pages.findIndex((page)=>{
		return page.pageId === action.payload.pageId
	});
	let removed = pages.splice(index, 1);
	return {
		...state,
		searchResult: pages,
		selectedItem: (removed?.[0].pageId ?? -1) !== state.selectedItem.pageId ? state.selectedItem: pages.length > 0 ? pages[0] : {}
	}
};

const onPageUpdated = (state: SearchState, action: any): SearchState => {
  let pages = state.searchResult;
	let selectedPage = state.selectedItem;
	let index = pages.findIndex((page)=>{
		return page.pageId === action.payload.pageId
	});
	if(index !== -1){
    // const temp = pages[0];
		// pages[index] = temp;
    // pages[0] = action.payload;
  
		pages[index] = action.payload;

  }
	else
		pages.unshift(action.payload);

	return {
		...state,
		selectedItem: selectedPage.pageId === action.payload.pageId ? {...action.payload}: selectedPage,
    searchResult: pages.filter(data => data).sort((a,b) => (moment(b.lastSent?.updatedAt ?? b.persistent.static.metadata.createdAt) as any) - (moment(a.lastSent?.updatedAt ?? a.persistent.static.metadata.createdAt) as any))
		// searchResult: [...pages]
	};
};

const onPageFocus = (state: SearchState, action: any): SearchState => {
  let pages = state.searchResult;
	let index = pages.findIndex((page)=>{
		return page.pageId === action.payload.pageId
	});
	if(index !== -1){
    pages.splice(index, 1)
  }
  pages.unshift(action.payload);
	return {
		...state,
		focusItem: action.payload,
    searchResult: pages
	};
};


const selectFriendPage = (state: SearchState, action: any): SearchState => {
  let pages = state.searchResult;	
  let index = pages.findIndex((page)=>{
		return page.pageId === action.payload.pageId
	});
	if(index !== -1){
    const temp = pages[0];
		pages[index] = temp;
    pages[0] = action.payload;
  }
	else
		pages.unshift(action.payload);

    console.log('action payload', action.payload);


    console.log('pages here', pages)
	return {
		...state,
		selectedItem: {...action.payload},
    searchResult: [...pages]
	};
};

const onPageReadBy = (state: SearchState, action: any): SearchState => {
  const readBy = [...(state.readBy || [])];
  const { pageId, read } = action.payload;
  readBy[pageId] = read;
  return {
    ...state,
    readBy,
  };
};

const onPageConnection = (state, action) => {
	return {
		...state,
		pageConnection: action.payload
	};
}

const onSearchPage = (state, action) => {
  let searchArgs = action.payload;
  console.log('on search page', searchArgs, searchArgs.reset)
	return {
		...state,
		searchArgs: searchArgs,
    searchPage: searchArgs.reset? initialState.searchPage: state.searchPage
	};
}

const searchReducer = (
  state: SearchState = initialState,
  action: any
): SearchState => {
  switch (action.type) {
    case "GET_SEARCH":
      return getSearch(state);
    case "SET_SELECTED_ITEM":
      return getSelectedSearchItem(state, action);
    case "SET_SEARCH_RESULT":
      return getSearchResults(state, action);
    case "SET_MAP_TYPE":
      return { ...state, mapType: action.payload };
    case "SET_TWILIO_TOKEN":
      return { ...state, twilioToken: action.payload };
    case "SET_INCOMING_CALL":
      return { ...state, callNotification: action.payload };
    case "SET_INCOMING_CALL_ENDED":
      return { ...state, callNotification: action.payload };
    case "SET_SAVE_VIDEO_PROMPT":
      return { ...state, saveRecordingNotification: action.payload };
    case "SET_TWILIO_VIDEO_URL":
      return { ...state, twilioVideoURL: action.payload };
    case "RESET_STATE":
      return {
        ...state,
        saveRecordingNotification: undefined,
        callNotification: undefined,
        twilioVideoURL: undefined,
      };
    case "PAGE_UPDATE":
      return onPageUpdated(state, action);
    case "PAGE_FOCUS":
      return onPageFocus(state, action);  
    case "PAGE_REMOVE":
      return onPageRemoved(state, action);
    case "PAGE_READ_BY":
      return onPageReadBy(state, action);
    case "PAGE_TYPING":
      return { ...state, pageTyping: action.payload };
    case "SEARCH_PAGE":
      return onSearchPage(state, action);
    case 'SET_CONNECTION': return onPageConnection(state, action);
    case "SET_USER_SEARCH_PAGE":
      return {
        ...state,
        userSearchPage: action.payload
      };
    case "SET_SEARCH_ADMIN_GROUP":
      return {
        ...state,
        adminSearchGroup: action.payload
      };  
    case "SET_FRIEND_SEARCH_PAGE":
      return {
        ...state,
        friendSearchPage: action.payload
      };
    case "SET_ALL_FRIEND_SEARCH_PAGE":
      return {
        ...state,
        friendPages: action.payload
      };
    case "SELECT_FRIEND_PAGE":
      return selectFriendPage(state, action);  
    case "SET_COPY_PAGE":
      return {
        ...state,
        copyPageId: action.payload
      };
    default:
      return state;
  }
};

export default searchReducer;
